import React from "react";
import logoUrl from "@/assets/logo.svg";

interface SlackMessagePreviewProps {
  children: React.ReactNode;
}

export function SlackMessagePreview({
  children,
}: SlackMessagePreviewProps): React.ReactElement {
  return (
    <div className="rounded-3xl border bg-background/50 overflow-hidden">
      <div className="px-4 py-4">
        {/* Message header row */}
        <div className="flex items-center gap-2.5 mb-2">
          <img
            src={logoUrl}
            alt="Infralyst"
            className="size-9 rounded-lg flex-none"
          />
          <div className="flex items-center gap-1.5 min-w-0">
            <span className="font-bold text-sm text-foreground leading-none">
              Infralyst
            </span>
            <span className="px-1 py-px rounded text-[10px] bg-foreground/10 text-foreground/50 font-semibold uppercase tracking-wide leading-none">
              APP
            </span>
            <span className="text-xs text-foreground/50">10:03</span>
          </div>
        </div>

        {/* Attachment — indented to align with text */}
        <div className="ml-11">
          {children}
        </div>
      </div>
    </div>
  );
}
